import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-large);
  width: 100%;
  max-width: 668px;

  @media (width >= 48rem) {
    gap: 47px;
  }
`;

export const HGroup = styled.hgroup`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);

  & h2 {
    font-size: var(--font-size-text-xl);

    @media (width >= 48rem) {
      font-size: var(--font-size-display-xs);
    }
  }
`;
